import React, { useState } from 'react';
import { DropResult } from 'react-beautiful-dnd';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Switch,
  Accordion,
  FormGroup,
  Typography,
  AccordionDetails,
  AccordionSummary,
  FormControlLabel,
} from '@mui/material';

import useLocales from '../../../hooks/useLocales';
import FormApproversList from './FormApproversList';
import { DraggableApproverProps } from '../../../@types/forms/types';

// ----------------------------------------------------------------------

type FormApproversProps = {
  isDocLogixIntegration: boolean;
  setIsDocLogixIntegration: (isDocLogixIntegration: boolean) => void;
  items: DraggableApproverProps[];
  handleItemChange: (item: DraggableApproverProps) => void;
  onDragEnd: (dropResult: DropResult) => void;
};

const FormApprovers: React.FC<FormApproversProps> = ({
  isDocLogixIntegration,
  setIsDocLogixIntegration,
  items,
  handleItemChange,
  onDragEnd,
}) => {
  const { t } = useLocales();
  const [isApproversExpanded, setIsApproversExpanded] = useState(false);

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsDocLogixIntegration(event.target.checked);
  };

  return (
    <Accordion id="forms-approvers-accordion" sx={{ p: 3 }} expanded={isApproversExpanded}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={[{
          px: 3
        }, isApproversExpanded ? {
          py: 3
        } : {
          py: 2
        }]}
        onClick={() => setIsApproversExpanded(!isApproversExpanded)}
        id="A8LquA"
      >
        <Typography variant="h6">{t('forms.approvers')}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ width: '100%', py: 3, pl: 3, pr: 2, pt: 0 }}>
        <FormGroup
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'left',
            alignItems: 'center',
          }}
        >
          <FormControlLabel
            control={
              <Switch
                id="doclogix-integration-switch"
                checked={isDocLogixIntegration}
                onChange={handleSwitchChange}
              />
            }
            label={t('forms.doclogixIntegration')}
            labelPlacement="start"
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'left',
              alignItems: 'center',
              gap: 1,
            }}
          />
        </FormGroup>

        <FormApproversList
          isDocLogixIntegration={isDocLogixIntegration}
          items={items}
          handleItemChange={handleItemChange}
          onDragEnd={onDragEnd}
        />

        {!isDocLogixIntegration && (
          <Typography variant="caption">{t('formTemplates.checkDragDropReorderList')}</Typography>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default FormApprovers;
